__turbopack_context__.v({
  "nav_button": "categories-grid-module-scss-module__cH0fMq__nav_button",
  "next": "categories-grid-module-scss-module__cH0fMq__next",
  "prev": "categories-grid-module-scss-module__cH0fMq__prev",
  "root": "categories-grid-module-scss-module__cH0fMq__root",
});
